import React from 'react';

import Rating from './components/Rating';
import Reviews from './components/Reviews';
import Benefits from './components/Benefits';
import SchemaOrg from './SchemaOrg';

import styles from './Kununu.css';
import { KununuReviews, KununuData } from './types';

type Props = {
  pageSlug: string;
  companyName: string;
  recommendation?: number;
  score?: number;
  kununuReviews?: KununuReviews;
  isEditor?: boolean;
} & Pick<
  KununuData,
  | 'benefits'
  | 'employerRatingsCount'
  | 'kununuCommentsUrl'
  | 'profileUuid'
  | 'companyProfileUrl'
  | 'evaluateProfileUrl'
>;

const Kununu = ({
  isEditor,
  pageSlug,
  companyProfileUrl,
  score,
  recommendation,
  benefits,
  companyName,
  kununuCommentsUrl,
  employerRatingsCount,
  kununuReviews,
  profileUuid,
  evaluateProfileUrl,
}: Props) => (
  <div className={styles.wrapper} data-testid={'KUNUNU_MODULE'}>
    <Rating
      isEditor={isEditor}
      score={score}
      recommendation={recommendation}
      profileUrl={companyProfileUrl}
    />
    {kununuReviews && kununuReviews.total > 0 && (
      <Reviews
        isEditor={isEditor}
        kununuReviews={kununuReviews}
        kununuCommentsUrl={kununuCommentsUrl}
      />
    )}
    {benefits.length > 0 && (
      <Benefits
        benefits={benefits}
        companyProfileUrl={companyProfileUrl}
        employerRatingsCount={employerRatingsCount}
        profileUuid={profileUuid}
        evaluateProfileUrl={evaluateProfileUrl}
      />
    )}
    {companyName && kununuReviews && kununuReviews.total > 0 && score && (
      <SchemaOrg
        pageSlug={pageSlug}
        companyName={companyName}
        reviewsCount={kununuReviews?.total}
        ratingValue={score}
      />
    )}
  </div>
);

export default React.memo(Kununu);
